import React  from "react";
import DrawerItemHeader from "../drawer-header";
import useStyles from "./styles.css";
import { View } from "react-native";
import DrawerItemBody from "./body";
import { useWindowDimensions } from "react-native";
import { DrawerContext } from "../drawer-provider";

const DrawerBody = () => {
  const styles = useStyles();
  const { height } = useWindowDimensions();
  const { activeTab } = React.useContext(DrawerContext);
  const isFullBanner = (activeTab === "Dashboard" || activeTab === "Document Cancelled " || activeTab === "Document Sent");

  return (
    <View style={[isFullBanner ? styles.full_banner_item_container : styles.drawer_item_container]}>
      {/* RANDOLF STICKY HEADER COMMENTED OUT */}
      {/* <DrawerItemHeader /> */}
      {/*<View style={{ ...styles.v_body, height: height - 117.5 }}>*/}
      <View style={{ ...styles.v_body }}>
        <DrawerItemBody />
      </View>
    </View>
  );
};

export default DrawerBody;
